import { LogoutUser } from "./CommonFunction";

const baseUrlConversion = () => {
  let baseUrl = process.env.REACT_APP_BASEURL;
  if (window.location.protocol === "http:") {
    baseUrl = baseUrl.replace("https", "http");
    return baseUrl;
  } else {
    return baseUrl;
  }
};

const handleResponse = async (response) => {
  if (response.status === 403) {
    LogoutUser();
    return Promise.reject("403 Forbidden: Logging out.");
  }
  return response.json();
};

export const fetchGet = async (endpoint) => {
  let baseUrl = baseUrlConversion();
  let response = await fetch(`${baseUrl}${endpoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${global.token}`,
    },
  });
  return handleResponse(response);
};

export const fetchPost = async (apiName, data, token) => {
  let baseUrl = baseUrlConversion();
  let response = await fetch(`${baseUrl}${apiName}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};

// For posting form data
export const fetchPost2 = async (apiName, formData, token) => {
  let response = await fetch(`${process.env.REACT_APP_BASEURL}${apiName}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return handleResponse(response);
};

export const fetchDelete = async (apiName, data, token) => {
  let baseUrl = baseUrlConversion();
  let response = await fetch(`${baseUrl}${apiName}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return handleResponse(response);
};
